const matchExactly = (value, match) => {
  const matched = value.match(match)

  return matched && matched[0] === value
}

export const isSsn = (value) => {
  const rutRegex = /^([0-9]{7,9}[\dkK])/

  return matchExactly(value, rutRegex)
}
